import { Component } from '@angular/core';

@Component({
  moduleId: module.id,
  templateUrl: 'loading-dialog.component.html'
})

export class LoadingDialogComponent {}



// WEBPACK FOOTER //
// /app/src/app/shared/loading-dialog/loading-dialog.component.ts